import Component from '~/components/component';
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';

export default class TextSlider extends Component {
	constructor(...args) {
		super(...args);
		this._initDom();
		this.swiper = null;
	}

	_initDom() {
		this.dom.swiperContainer = this._find('.js-swiper');
		this.dom.next = this._find('.swiper-button-next');
		this.dom.prev = this._find('.swiper-button-prev');
		this.dom.pagination = this._find('.swiper-pagination');
	}

	init() {
		super.init();
		this._initSwiper();
	}

	_initSwiper() {
		if (this.dom.swiperContainer) {
			this.swiper = new Swiper(this.dom.swiperContainer, {
				modules: [Autoplay, Navigation, Pagination],
				autoplay: {
					delay: 5000,
					disableOnInteraction: false,
				},
				slidesPerView: 1,
				loop: true,
				speed: 500,
				navigation: {
					nextEl: this.dom.next,
					prevEl: this.dom.prev,
				},
				pagination: {
					el: this.dom.pagination,
					clickable: true,
				},
			});
		}
	}
}
